interface Dependency {
    id: string;
    check: (() => boolean) | boolean;
}

export const isSecureContext: Dependency = {
    id: "isSecureContext",
    check: () => window.isSecureContext,
}
export const webCrypto: Dependency = {
    id: "webCrypto",
    check: () => !!window.crypto,
}
export const webWorkers: Dependency = {
    id: "webWorkers",
    check: () => typeof Worker === "function" && typeof Worker.prototype.postMessage === "function",
}
export const broadcastChannel: Dependency = {
    id: "broadcastChannel",
    check: () => typeof BroadcastChannel === "function" && typeof BroadcastChannel.prototype.postMessage === "function",
}
export const abortController: Dependency = {
    id: "abortController",
    check: () => typeof AbortController === "function" && typeof AbortController.prototype.abort === "function",
}
export const webLocks: Dependency = {
    id: "webLocks",
    check: () => !!navigator.locks,
}
export const bigInt: Dependency = {
    id: "bigInt",
    check: () => typeof BigInt === "function",
}
export const dataView: Dependency = {
    id: "dataView",
    check: () => typeof DataView === "function" && typeof DataView.prototype.setBigUint64 === "function",
}

export function checkDependencies() {
    for (const dep of [isSecureContext, abortController, webCrypto, webWorkers, broadcastChannel, webLocks, bigInt, dataView]) {
        if (typeof dep.check === "function") {
            try {
                dep.check = dep.check();
            } catch (err) {
                console.error(`Dependency check failed for ${dep.id}:`, err);
                dep.check = false;
            }
        }
        if (!dep.check) {
            return dep.id
        }
    }
    return undefined;
}